let totalNum=0;
const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
          NumAutoPlusAnimation(0,totalNum);
          observer.disconnect();
        }
    });
});

let numId = document.getElementById("countNumber");
function NumAutoPlusAnimation(startNum, endNum ) {
    let step = (endNum - startNum) / 20;
    let count = startNum;
    let timer = setInterval(() => {
        count = count + step;
        if (count >= endNum) {
            clearInterval(timer);
            count = endNum;
            return numId.innerHTML = count?addCommas(count):addCommas(totalNum)
        }
        numId.innerHTML = addCommas(count.toFixed(0))
    }, 30);
}
function addCommas(nStr) {
    nStr += '';
    x = nStr.split('.');
    x1 = x[0];
    x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
} 
document.addEventListener('DOMContentLoaded', function() {
   const target = document.getElementById('countNumber');
    totalNum=Number(document.getElementById('countNumber').innerHTML.toString().replace(/,/g, ''))
    observer.observe(target);
});